export default __webpack_public_path__ + "static/media/scratch_f_loader_nobg_500x500_v02.34ae911b.gif";